export default class TemplatesCtrl {
    constructor($state, $filter, SideMenu, Template, SweetAlert, Events) {
        SideMenu.setActive('template');
        this._translator = $filter('translate');
        this._state = $state;

        this.templateRepo = Template;
        this.alerter = SweetAlert;
        this.eventHandler = Events;

        this.templates = [];
        this.templatesByType = {};

        this.templateRepo.get().then((templates) => {
            angular.forEach(templates.data, (template) => {
                if (template.templateType) {
                    let typeName = template.templateType.data.name;
                    if (!this.templatesByType.hasOwnProperty(typeName)) {
                        this.templatesByType[typeName] = [];
                    }
                    this.templatesByType[typeName].push(template);
                } else {
                    this.templates.push(template);
                }
            });
        });
    }

    edit(id) {
        this._state.go('template.edit', { id: id });
    };


    delete(template, index, event) {
        event.stopPropagation();

        this.alerter.swal({
            title: this._translator('GLOBAL:DELETE'),
            text: this._translator('TEMPLATE:INDEX:DELETE_BODY').replace(/:name/, template.name),
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55"
        }, (isConfirmed) => {
            if (isConfirmed) {
                this.templateRepo.delete(template.id).then((res) => {
                    if (res.success) {
                        this.eventHandler.flashEvent('notification', this._translator('TEMPLATE:DELETED'));
                        this._state.go(this._state.current, {}, { reload: true });
                    }
                 }, (err) => {
                    this.eventHandler.flashEvent('error', err.data.message);
                });
            }
        });
    };
};
